"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDontAskForNotification = void 0;
var timeConstants_1 = require("../../constants/timeConstants");
var getDontAskForNotification = function (_a) {
    var _b;
    var state = _a.state;
    var dontAskToEnableNotificationMs = (_b = state.cookieStorage) === null || _b === void 0 ? void 0 : _b.dontAskToEnableNotificationMs;
    if (dontAskToEnableNotificationMs) {
        return dontAskToEnableNotificationMs > Date.now() - timeConstants_1.SECONDS_IN_A_WEEK * 1000;
    }
    return false;
};
exports.getDontAskForNotification = getDontAskForNotification;
